import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Brand";
import { FOOTER_COLUMNS, BRAND } from "@/lib/site";
import { useConsent } from "@/lib/consent";

export default function Footer() {
  const { openPreferences } = useConsent();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-etap-deep text-white" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <Logo testId="footer-logo" variant="white" />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-etap-deep-100">
              {BRAND.tagline} ETAP routes your set aside toward federal and state estimated taxes the moment income lands.
            </p>
            <p className="mt-4 text-sm font-semibold text-etap-mint-200">Non custodial. ETAP never holds your money.</p>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:col-span-8">
            {FOOTER_COLUMNS.map((col) => (
              <div key={col.title}>
                <h3 className="font-display text-sm font-bold uppercase tracking-wider text-etap-mint-200">
                  {col.title}
                </h3>
                <ul className="mt-4 space-y-3">
                  {col.links.map((l) => (
                    <li key={l.to}>
                      <Link
                        to={l.to}
                        className="text-sm text-etap-deep-100 transition-colors hover:text-white"
                        data-testid={`footer-link-${l.to.replace("/", "")}`}
                      >
                        {l.label}
                      </Link>
                    </li>
                  ))}
                  {col.title === "Legal" && (
                    <li>
                      <button
                        type="button"
                        onClick={openPreferences}
                        className="text-sm text-etap-deep-100 transition-colors hover:text-white"
                        data-testid="footer-cookie-settings"
                      >
                        Cookie Settings
                      </button>
                    </li>
                  )}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 border-t border-white/10 pt-8">
          <p className="text-xs leading-relaxed text-etap-deep-100">
            ETAP does not provide tax, legal, or accounting advice. ETAP is a product of Flynaut LLC. Bank access is read
            only through Plaid. Payment movement is authorized through Stripe.
          </p>
          <p className="mt-4 text-xs text-etap-deep-200">Copyright {year} Flynaut LLC. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
